import React, { useState, useCallback, useEffect } from "react";
import logo from "./images/logo.png";
import shuttle from "./images/shuttle.png";
import wts from "./images/wts.png";

import moment from "moment";
import _ from "lodash";
import marker from "./images/marker.svg";
import flag from "./images/flag.svg";

import GoogleMapReact from "google-map-react";

import { Provider } from "react-redux";
import configStore from "./redux/configStore";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { updateBusLocation, getBusETA, updateEta } from "./redux/action";

import "./App.css";
import debugLog, {LogLevel} from "./utils/debugLog";

const ROUTE = [
  {
    createdAt: "2021-02-09T03:01:22.866763",
    description:
      "Qui dolor ad velit fugiat.↵Possimus reprehenderit consequuntur aut.↵Dolorum atque fugit dolor consequuntur nesciunt aut.↵Possimus totam enim nulla voluptates sit provident ducimus libero enim.",
    id: 8,
    name: "8:10 timeable",
    publishedName: "Downtown East",
    segments: [
      {
        createdAt: "2021-02-09T03:01:23.553662",
        endLocation: null,
        endLocationId: 2,
        estimatedEndTime: "08:40:00",
        estimatedEndTimeString: "08:40:00",
        estimatedStartTime: "08:20:00",
        estimatedStartTimeString: "08:20:00",
        id: 91,
        routeId: 8,
        segmentLogs: null,
        startLocation: null,
        startLocationId: 1,
        updatedAt: "2021-02-09T03:01:23.553663",
      },
      {
        createdAt: "2021-02-09T03:01:23.559929",
        endLocation: null,
        endLocationId: 4,
        estimatedEndTime: "08:50:00",
        estimatedEndTimeString: "08:50:00",
        estimatedStartTime: "08:40:00",
        estimatedStartTimeString: "08:40:00",
        id: 92,
        routeId: 8,
        segmentLogs: null,
        startLocation: null,
        startLocationId: 2,
        updatedAt: "2021-02-09T03:01:23.559929",
      },
    ],
  },
  {
    createdAt: "2021-02-09T03:01:22.866763",
    description:
      "Qui dolor ad velit fugiat.↵Possimus reprehenderit consequuntur aut.↵Dolorum atque fugit dolor consequuntur nesciunt aut.↵Possimus totam enim nulla voluptates sit provident ducimus libero enim.",
    id: 8,
    name: "8:10 timeable",
    publishedName: "WRS Zoo",
    segments: [
      {
        createdAt: "2021-02-09T03:01:23.553662",
        endLocation: null,
        endLocationId: 2,
        estimatedEndTime: "08:40:00",
        estimatedEndTimeString: "08:40:00",
        estimatedStartTime: "08:20:00",
        estimatedStartTimeString: "08:20:00",
        id: 91,
        routeId: 8,
        segmentLogs: null,
        startLocation: null,
        startLocationId: 1,
        updatedAt: "2021-02-09T03:01:23.553663",
      },
      {
        createdAt: "2021-02-09T03:01:23.559929",
        endLocation: null,
        endLocationId: 4,
        estimatedEndTime: "08:50:00",
        estimatedEndTimeString: "08:50:00",
        estimatedStartTime: "08:40:00",
        estimatedStartTimeString: "08:40:00",
        id: 92,
        routeId: 8,
        segmentLogs: null,
        startLocation: null,
        startLocationId: 2,
        updatedAt: "2021-02-09T03:01:23.559929",
      },
    ],
  },
];

const signalR = require("@microsoft/signalr");
const connection = new signalR.HubConnectionBuilder()
  .withUrl(`${process.env.REACT_APP_SERVER_URL}/SignalRHubs/RealtimeVehicle`, {
    accessTokenFactory: () => "",
  })
  .configureLogging(signalR.LogLevel.Information)
  .build();

const { store } = configStore();

const mapStateToProps = ({ main }: any) => ({
  busData: main.busData,
  locations: main.locations,
});

const mapDispatchToProps = (dispatch: any) => {
  return bindActionCreators(
    { getBusETA, updateBusLocation, updateEta },
    dispatch
  );
};

const Main = connect(
  mapStateToProps,
  mapDispatchToProps
)(({ busData, ...props }: any) => {
  const [isConnected, setConnected] = useState(false);
  const [routeToSubscribe, setRouteToSubscribe] = useState<any[]>([]);
  const [locations, setLocations] = useState<any>([]);
  const [locationEtas, setLocationEtas] = useState<any>([]);

  useEffect(() => {
    startConnection();
    props.getBusETA((ids: any) => {
      setRouteToSubscribe(ids);
    });

    let updateInterval = setInterval(() => {
      debugLog(LogLevel.INFO, 'UPDATE CORE DATA EVERY 1 Minute', {});
      props.getBusETA((ids: any[]) => {
        setRouteToSubscribe(ids);
      });
    }, 60000);

    return () => {
      clearInterval(updateInterval);
    };
  }, []);

  const startConnection = async () => {
    try {
      await connection.start();

      connection.on("BroadcastEta", (data: any) => {
        debugLog(LogLevel.INFO, `BROADCAST DATA FROM VEHICLE #${data.vehicle.id}`, {
            data: data,
        });
        props.updateBusLocation(data);
      });

      setConnected(true);

      connection.onclose(() => {
        setConnected(false);
        debugLog(LogLevel.INFO, 'Connection Closed. ', {
            connection: connection,
        });
        connection.stop();
        startConnection();
      });

      debugLog(LogLevel.INFO, 'SignalR Connected.', {});
    } catch (err) {
      debugLog(LogLevel.ERROR, 'Unable to connect to SingalR. ', {
          err: err,
      });
      setConnected(false);
    }
  };

  useEffect(() => {
    if (isConnected && routeToSubscribe.length !== 0) {
      debugLog(LogLevel.INFO, 'SUBSCRIBE', {});

      routeToSubscribe.forEach(async (id: number) => {
        try {
          debugLog(LogLevel.INFO, 'SUBSCRIBE TO Route:', {
            routeId: id
          });
          await connection.invoke("JoinGroup", `route:${id}`);

          debugLog(LogLevel.INFO, 'SUBSCRIBED TO Route:', {
            routeId: id
          });
        } catch (err) {
          debugLog(LogLevel.ERROR, 'Unable to subscribe to route. ', {
            err: err,
            routeId: id,
          });
        }
      });
    }
  }, [isConnected, routeToSubscribe]);

  //refresh display data only if segment data from props changed
  useEffect(() => {
    const mapped = props.locations.map((item: any) => {
      return {
        ...item,
        activeBuses: [],
      };
    });

    setLocations(mapped);
  }, [props.locations]);

  useEffect(() => {
    let updateLocation = _.cloneDeep(locations);

    //iterate all locations
    updateLocation.forEach((locationItem: any) => {
      //filter bus heading to location id
      const filteredBus = _.filter(busData, (o: any) => {
        return o.toLocation.id === locationItem.id;
      });

      //sort bus by earliest eta
      let sortedBuses: any = _.orderBy(filteredBus, (item: any) => {
        return moment(item.eta);
      });

      if (sortedBuses.length === 0) {
        if (busData.length !== 0) {
          let emptyEta: any = _.cloneDeep(_.first(busData));
          emptyEta.eta = moment(emptyEta.eta).add(6, "m").toString();
          emptyEta.isHidden = true;

          debugLog(LogLevel.WARNING, 'EMPTY ETA`. ', {
            emptyEta: emptyEta,
          });
          sortedBuses = [emptyEta];
        } else {
          sortedBuses = [undefined];
        }
      }
      locationItem.activeBuses = sortedBuses.slice(0, 2);
    });

    setLocationEtas(updateLocation);
  }, [busData, locations]);

  return (
    <div className="App">
      <div className="Wrapper">
        <div className="Mobile-Wrapper">
          <img src={logo} alt="logo" className="Logo" />
          <img src={shuttle} alt="shuttle" />
        </div>
        <div className="Selection-Wrapper">
          <img src={logo} alt="logo" className="Logo" />
          <img src={shuttle} alt="shuttle" />
        </div>

        {/* Only Show if layout is at least 1130px wide */}
        <div className="Map-Wrapper">
          <div className="Map">
            <GoogleMapReact
              bootstrapURLKeys={{
                key: "AIzaSyDYGvy_HvsUfvJ_7_d4PmOH201jIFNn-iM",
              }}
              defaultCenter={{
                lat: 1.3748604812816714,
                lng: 103.95002651843096,
              }}
              // onClick={onMapClick}
              defaultZoom={17}
            >
              {locationEtas.map((locationEta: any) => {
                let comp = [];

                locationEta.activeBuses.map((activeBus: any) => {
                  if (activeBus) {
                    if (!activeBus.isHidden) {
                      comp.push(
                        <BusMarker
                          bus={activeBus}
                          key={activeBus.vehicle.id}
                          lat={activeBus.vehicle.lastLocationLat}
                          lng={activeBus.vehicle.lastLocationLng}
                        />
                      );
                    }
                  }
                });

                comp.push(
                  <FlagMarker
                    key={locationEta.id}
                    lat={locationEta.lat}
                    lng={locationEta.lng}
                  />
                );

                return comp;
              })}
            </GoogleMapReact>
          </div>
          <div className="Route-Wrapper">
            <div className="Route-Big-Header">
              <div className="Text-Wrapper-Center">
                <span className="Text-Title">Next Bus Arriving</span>
              </div>
            </div>

            <div className="Route-Header">
              <div className="Text-Wrapper">
                <span className="Text-Title">Pick Up Point</span>

                <span className="Text-Detail">ETA</span>
              </div>
            </div>
            <div className="Route-Body">
              {locationEtas.map((locationEta: any, index: number) => {
                return (
                  <EtaDisplayItem
                    key={index}
                    location={locationEta}
                    index={index}
                  />
                );
              })}

              {/* <div className="Text-Body-Wrapper Border-Bottom Top-Margin">
                <div className="Segment-Title-Wrapper">
                  <span className="Segment-Title">Pasir Ris MRT</span>
                </div>
                <span className="Text-Time">
                  5<span className="Text-Min">min</span>
                </span>
                <span className="Text-Time">
                  12<span className="Text-Min">min</span>
                </span>
              </div> */}
            </div>
            <div className="Route-Logo-Header">
              <img src={wts} style={{ width: "250px" }} alt="wts" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

const EtaDisplayItem = ({ location, index }: any) => {
  const getETAText = useCallback((bus, idx) => {
    if (bus === undefined) {
      return <span className="Text-Empty-ETA">-</span>;
    }

    if (
      bus.assignmentLocation.status === "arrived" &&
      bus.toLocation.id !== bus.fromLocation.id &&
      bus.isHidden
    ) {
      return (
        <span key={`etabus-${bus.vehicle.id}`} className="Text-Note">
          BOARDING
        </span>
      );
    }

    const now = moment();
    const remaining = moment.duration(moment(bus.eta).diff(now)).asMinutes();
    if (remaining < 1 && remaining > 0.25) {
      return (
        <span key={`etabus-${bus.vehicle.id}`} className="Text-Note">
          ARRIVING
        </span>
      );
    } else if (remaining <= 0.25) {
      return (
        <span key={`etabus-${bus.vehicle.id}`} className="Text-Note">
          ARRIVED
        </span>
      );
    } else {
      return (
        <span key={`etabus-${bus.vehicle.id}`} className="Text-Time">
          {`${Math.floor(remaining)}`}
          <span className="Text-Min">min</span>
        </span>
      );
    }
  }, []);

  return (
    <div
      className={`Text-Body-Wrapper Border-Bottom ${
        index !== 0 ? "Top-Margin" : ""
      }`}
    >
      <div className="Segment-Title-Wrapper">
        <span className="Segment-Title">{location.name}</span>
      </div>
      <div className="Segment-ETA">
        {location.activeBuses.map((bus: any, idx: number) => {
          return getETAText(bus, idx);
        })}
      </div>
    </div>
  );
};

const BusMarker = ({ bus, ...props }: any) => {
  const getETA = useCallback(() => {
    if (
      bus.assignmentLocation.status === "arrived" &&
      bus.toLocation.id !== bus.fromLocation.id &&
      bus.isHidden === undefined
    ) {
      return <div className="Marker-ETA-Boarding">{`BOARDING`}</div>;
    }

    const now = moment();

    const remaining = moment.duration(moment(bus.eta).diff(now)).asMinutes();

    if (remaining < 1 && remaining > 0.25) {
      return <div className="Marker-ETA-Arriving">{`ARRIVING`}</div>;
    } else if (remaining <= 0.25) {
      return <div className="Marker-ETA-Arr">{`ARRIVED`}</div>;
    } else {
      return <div className="Marker-ETA">{`${Math.floor(remaining)}min`}</div>;
    }
  }, [bus]);

  return (
    <div className="Marker-Wrapper">
      {getETA()}

      <img className="Marker-Icon" src={marker} alt="Bus Marker" />
    </div>
  );
};

const FlagMarker = (props: any) => {
  return (
    <div className="Marker-Wrapper">
      <img className="Marker-Icon-Flag" src={flag} alt="Flag Marker" />
    </div>
  );
};

const App = () => {
  return (
    <Provider store={store}>
      <Main></Main>
    </Provider>
  );
};

export default App;
